module.exports = __webpack_public_path__ + "img/ALICEAUVILLA.815c16ac.png";